import { gql } from '@apollo/client'

export const GET_CLIENT_THEME = gql`
  query {
    clientTheme {
      logo_url
      primary_color
      secondary_color
    }
  }
`
